import type { CompileResult } from '../engine/types';

/**
 * What the engine actually verified:
 * - 'rows'   : at least one pattern row was understood and executed;
 * - 'module' : no understood rows, but a dedicated module (garment schedule, short-row heel)
 *              verified steps listed in module_trace;
 * - 'none'   : nothing was understood. The absence of diagnostics then means nothing, and the UI
 *              must never present it as a success.
 */
export type AnalysisState = 'rows' | 'module' | 'none';

export function analysisState(result: CompileResult): AnalysisState {
  if (result.rows.length > 0 && result.coverage.n_understood > 0) return 'rows';
  if ((result.module_trace?.length ?? 0) > 0) return 'module';
  return 'none';
}
